var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 51,
    viewBox: "0 0 40 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8504 39.2878V48.0857C28.8504 49.0056 28.127 49.7535 27.2318 49.7535H2.61862C1.72584 49.7535 1 49.0056 1 48.0857V2.66783C1 1.74791 1.72584 1 2.61862 1H27.2318C28.127 1 28.8504 1.74791 28.8504 2.66783V25",
    stroke: "#F4C135",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 44.5H19",
    stroke: "#E98432",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.996 36L25.3 34.128H21.532L20.836 36H18.988L22.336 27.252H24.508L27.868 36H25.996ZM23.404 29.004L22.132 32.448H24.676L23.404 29.004ZM35.2397 30.06C35.2397 30.996 34.9157 31.752 34.3277 32.208C33.7517 32.676 32.9717 32.916 32.0477 32.916H30.6797V36H28.8677V27.252H32.1077C33.0077 27.252 33.7757 27.492 34.3397 27.96C34.9037 28.416 35.2397 29.16 35.2397 30.06ZM33.4157 30.096C33.4157 29.556 33.0917 29.196 32.6717 29.064C32.4557 28.992 32.2277 28.956 31.9517 28.956H30.6797V31.236H31.9637C32.6837 31.236 33.4157 30.912 33.4157 30.096ZM36.5903 36V27.252H38.4023V36H36.5903Z",
    fill: "#E98432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/API.7703fb8d2ecc0c7bc1b169b80d2fd891.svg";
export { ForwardRef as ReactComponent };